import React, { Component } from "react";

class MultipleTabsMessage extends Component {
  render() {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          width: "100vw",
          backgroundColor: "#f5f5f5",
          fontFamily: "Arial, sans-serif",
          fontSize: "24px",
          color: "#333",
          textAlign: "center",
          padding: "20px",
          boxSizing: "border-box"
        }}
      >
        <div>This site is already open in another browser tab or window</div>
      </div>
    );
  }
}

export default MultipleTabsMessage;



// WEBPACK FOOTER //
// ./src/app/multiple-tabs-message.jsx